import { render } from "./WarehousePurchaseOrders.vue?vue&type=template&id=380418fd&scoped=true"
import script from "./WarehousePurchaseOrders.vue?vue&type=script&lang=js"
export * from "./WarehousePurchaseOrders.vue?vue&type=script&lang=js"

import "@/styles/warehouse.css?vue&type=style&index=0&id=380418fd&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380418fd"]])

export default __exports__